<template lang="pug">
.display-yaml.relative.overfow-visible(
  :class="expanded ? 'dark relative' : 'absolute'"
  aria-hidden="true"
  uc-word-skip=""
)
  .ks-buttons-absolute.right-2.top-1.flex.flex-row-reverse(
    :class="{ 'p-2': expanded }"
  )
    button.z-10.py-1.px-8.text-sm.font-semibold.text-gray-800.hover_bg-opacity-10.active_bg-opacity-20.disabled_opacity-20.dark_text-gray-200(
      :class="{ 'bg-transparent px-0 shadow-none': !expanded }"
      @click="toggle"
      class="disabled_bg-gray-500/50 hover_disabled_bg-gray-500/50"
    ) 
      span.font-mono.text-xs.font-bold {{ !expanded ? 'Show code' : 'Hide' }}
    button.mx-2.z-10.btn.btn-sm(@click="copy" v-if="expanded") 
      span.font-mono.text-xs.font-bold {{ copyLabel }}
  textarea.sr-only(ref="textareaRef") {{ indentedString }}
  transition-expand
    .text-left.prose.max-w-none.mb-20.bg-gray-800.flow-root.corners(
      v-if="expanded"
    )
      .simple-scrollbar.overflow-y-auto.p-1.m-1(class="max-h-[50vh]")
        highlight-code(:code="string" language="yaml")
</template>

<script setup>
import { computed, defineAsyncComponent, ref, onMounted } from 'vue';
import ScrollTrigger from 'gsap/ScrollTrigger';

// import HighlightCode from '../lib/highlight-code';

const loader = () => import('../lib/highlight-code');

onMounted(loader);

const HighlightCode = defineAsyncComponent({ loader });

const props = defineProps({
  object: { type: Object, required: true }
});

const expanded = ref(false);
const textareaRef = ref(null);
const copyLabel = ref('Copy');

// code split jsYaml
let dump = ref(() => '');

onMounted(async () => {
  const jsYaml = await import('js-yaml');
  dump.value = jsYaml.dump;
});

const objectWithRandomizedId = computed(() => {
  const obj = { ...props.object };

  if (obj.id) {
    obj.id = obj.id + '_' + Math.random().toString(16).slice(-10);
  }

  return obj;
});

const string = computed(() => {
  let s = dump.value(
    [objectWithRandomizedId.value],
    // https://github.com/nodeca/js-yaml/issues/467
    { lineWidth: -1 }
  );

  // remove screenIndex
  s = s.replace(/\n +screenIndex: \d+ *\n*/g, '\n');

  return s;
});

const indentedString = computed(
  () => '      ' + string.value.replace(/\n/g, '\n      ')
);

const toggle = async () => {
  expanded.value = !expanded.value;

  await new Promise(r => setTimeout(r, 200));

  ScrollTrigger.refresh();
};

const copy = () => {
  textareaRef.value.select();
  document.execCommand('copy');
  copyLabel.value = 'Copied!';

  setTimeout(() => {
    copyLabel.value = 'Copy';
  }, 2e3);
};
</script>

<style>
.ks-buttons-absolute {
  @apply absolute;
}

.screen .screen .display-yaml {
  display: none;
}

.display-yaml pre {
  white-space: pre-wrap;
  background: transparent;
  margin: 0;
}

.hljs-attr {
  color: rgba(var(--color-gray-50));
}

.hljs-string {
  color: rgba(var(--color-primary-300));
}

.hljs-literal,
.hljs-number {
  color: rgba(var(--color-secondary-300));
}
</style>
